const GAME_LIBRARY_URL = new URL('/', 'http://royal1.midasplayer.com')


export {
  GAME_LIBRARY_URL
}



// WEBPACK FOOTER //
// ./src/constants.js